import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PageWellComponent } from '../../components/page-well/page-well.component';
import { ResolveLibModule } from 'resolve-lib';
import { UserService } from '../../services/user.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LoadingScreenComponent } from '../../partials/loading-screen/loading-screen.component';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';

@Component({
    selector: 'app-sign-in',
    imports: [
        ResolveLibModule,
        LoadingScreenComponent
    ],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss'
})
export class SignInComponent implements OnInit, OnDestroy {
  #dataSubscriptions: Subscription = new Subscription();
  userService = inject(UserService);
  router = inject(Router);
  loadingService = inject(LoadingScreenService);

  ngOnInit(): void {
    this.loadingService.startLoading();
    this.#dataSubscriptions.add(
      this.userService.profile.subscribe(profile => {
        this.loadingService.stopLoading();
        if(profile !== null){
          this.router.navigateByUrl('/rdata-aggregates');
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.#dataSubscriptions.unsubscribe();
  }
}
